import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=53b5a624&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=53b5a624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5a624",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b5a624')) {
      api.createRecord('53b5a624', component.options)
    } else {
      api.reload('53b5a624', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=53b5a624&scoped=true&", function () {
      api.rerender('53b5a624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4nfp8MiWe6vGD/JS/comp/SearchFilterTokens.vue"
export default component.exports